export default "__VITE_ASSET__CQLmGAb1__"